import _ from 'lodash';
import React, { useRef } from 'react';

import { useIsOverflow } from '../../hooks/useIsOverflow';
import TextTooltip from '../TextTooltip';
import { BasicInfoBox } from './VehicleCard';
import {
  InfoBoxIcon,
  InfoBoxTitle,
  InfoBoxValue,
  InfoBoxValueContainer,
  InfoBoxValuesContainer,
  VehicleInfoBoxContainer,
} from './VehicleCard.styles';

export interface TextBox extends BasicInfoBox {
  value1?: string;
  value2?: string;
  value3?: string;
  icon1?: JSX.Element;
  icon2?: JSX.Element;
  icon3?: JSX.Element;
}

const VehicleTextBox = ({ data }: { data: TextBox }) => {
  const value1Ref = useRef();
  const isValue1Overflow = useIsOverflow(value1Ref, { skipVertical: true });

  const value2Ref = useRef();
  const isValue2Overflow = useIsOverflow(value2Ref, { skipVertical: true });

  const value3Ref = useRef();
  const isValue3Overflow = useIsOverflow(value3Ref, { skipVertical: true });

  /**
   *
   * @param text The text to truncate
   * @param length Amount of characters
   * @returns
   */
  const truncateText = (text: string, length: number) => {
    return _.truncate(text, {
      length: length,
      separator: ' ',
    });
  };

  return (
    // We use conditional rendering for each value so as to allow them to be empty
    // and not occupy space, as specified in the designs.
    <VehicleInfoBoxContainer $minWidth={data.minWidth} $maxWidth={data.maxWidth}>
      {data.title && <InfoBoxTitle>{data.title}</InfoBoxTitle>}
      <InfoBoxValuesContainer>
        <InfoBoxValueContainer>
          {data.icon1 && <InfoBoxIcon>{data.icon1}</InfoBoxIcon>}
          <TextTooltip tooltipText={truncateText(data.value1, 100)} isDisabled={!isValue1Overflow}>
            <InfoBoxValue ref={value1Ref}>{data.value1}</InfoBoxValue>
          </TextTooltip>
        </InfoBoxValueContainer>
        <InfoBoxValueContainer>
          {data.icon2 && <InfoBoxIcon>{data.icon2}</InfoBoxIcon>}
          {data.value2 && (
            <TextTooltip tooltipText={data.value2} isDisabled={!isValue2Overflow}>
              <InfoBoxValue ref={value2Ref}>{data.value2}</InfoBoxValue>
            </TextTooltip>
          )}
        </InfoBoxValueContainer>
        <InfoBoxValueContainer>
          {data.icon3 && <InfoBoxIcon>{data.icon3}</InfoBoxIcon>}
          {data.value3 && (
            <TextTooltip tooltipText={data.value3} isDisabled={!isValue3Overflow}>
              <InfoBoxValue ref={value3Ref}>{data.value3}</InfoBoxValue>
            </TextTooltip>
          )}
        </InfoBoxValueContainer>
      </InfoBoxValuesContainer>
    </VehicleInfoBoxContainer>
  );
};

export default VehicleTextBox;
